<div class="dam-transformation mt-3 mb-3">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-8">
        <label class="form-label">Название файла</label>
        <input placeholder="Название" status="warning" class="w-100" style="max-width: 100%" nbInput value="" formControlName="header">
      </div>
      <div class="col-4">
        <label class="form-label">Расширение файла (readonly)</label>
        <input status="warning" readonly nbInput value="{{fileExt}}">

      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <label>&nbsp;</label>
        <button nbButton class="button" type="submit" status="info" [disabled]="!form.valid"> Сохранить
          <nb-icon icon="save"></nb-icon>
        </button>

      </div>
    </div>
  </form>
</div>


